import React, {  useCallback, useEffect, useState } from 'react'

import { useDispatch } from 'react-redux'
import { useAppSelector } from '../../../../store/hooks'

import Section, { SectionBox, SectionOption } from '../../../../components/Section'
import getProtocolos from './Scripts/get'
import TableListarProtocolo from './Components/TableListarProtocolo'
import AgrupamentoComponent from './Components/AgrupamentoComponent'
import { MenuItem,Select as SelectMUI, TextField } from '@material-ui/core'
import { mdiMagnify } from '@mdi/js'
import filter from './Scripts/filter'

const Protocolos: React.FC = () => {

    const dispatch = useDispatch()
    const { protocolos, requestGet} = useAppSelector(state => state.ProtocoloReducer)
    const { userData } = useAppSelector(state => state.auth)
    const [dtInicio, setDtInicio] = useState<string>('')
    const [dtFim, setDtFim] = useState<string>('')
    const [flagAcompanhamento, setFlagAcompanhamento] = useState<string>('null')

    const PAGE_NAME = "Protocolos App"


    useEffect(() => {
        (async () => {await getProtocolos(dispatch)})()
    }, [dispatch])  
    
    const handleFilter = async () => {
        await filter(dispatch, { dtInicio , dtFim, flagAcompanhamento})
    }

    return (
        <>
            <Section name = "NameSection">
                <SectionBox 
                right={
                    <>
                        <TextField type="date" id="filterAnoInicial" variant="standard" className="fieldFilter" placeholder="Cliente" value={dtInicio} onChange={e => setDtInicio(e.target.value)}/>
                        <TextField type="date" id="filterAnoFinal" variant="standard" className="fieldFilter" placeholder="Cliente" value={dtFim} onChange={e => setDtFim(e.target.value)}/>
                        <SelectMUI id="filterAtivo" value={flagAcompanhamento} onChange={e => setFlagAcompanhamento(e.target.value as any)}>
                            <MenuItem value={'null'}>Acompanhamento</MenuItem>
                            <MenuItem value={'1'}>Sim</MenuItem>
                            <MenuItem value={'0'}>Não</MenuItem>
                        </SelectMUI>
                        <SectionOption icon = {mdiMagnify} tooltip = "Filtrar" onClick = {handleFilter} />
                    </>
                                            }
                    title = {PAGE_NAME}
                    padding = {false} >
                    {protocolos && <AgrupamentoComponent lista={protocolos} loading = {requestGet.loading} />}
                </SectionBox>
            </Section>
            <>
            </>
        </>
    )
}

export default Protocolos
